import React from "react"
import { Route, Redirect } from "react-router-dom"
import { useRights } from "../../hooks/rights"
import Loader from "../basics/Loader"

const ProtectedRoute = ({
	component: Component,
	isAuthenticated,
	hasRights,
	path,
}) => {
	// La matrice de droits arrive du serveur (api/access) APRÈS le premier
	// render. Rediriger avant de l'avoir reçue éjecterait l'utilisateur vers
	// /home à chaque F5 sur une route gatée : tant que `accessLoaded` est faux
	// on attend, on ne tranche pas. `hasRights === true` (route non gatée)
	// s'affiche immédiatement, sans attendre quoi que ce soit.
	const { accessLoaded } = useRights()

	return (
		<Route
			exact
			path={path}
			render={(props) =>
				!isAuthenticated ? (
					<Redirect to="/" />
				) : hasRights ? (
					<Component {...props} />
				) : !accessLoaded ? (
					<Loader variant="ring" message="Chargement…" />
				) : (
					<Redirect to="/home" />
				)
			}
		/>
	)
}

export default ProtectedRoute
